import React from 'react';
import { Link } from 'react-router-dom';
import './Homepage.css';
import principalImg from '../Images/principal.jpeg'; 
import Navbar from '../Navbar/Navbar';

const Homepage = () => {
  return (
     <>
      <Navbar />
       <main>

      {/* == HERO SECTION == */}
      <section className="hero">
        <div className="hero__content">
          <p className="hero__location">Little Flowers' School Odisha</p>
          <h1 className="hero__title">Where every flowers Blossom<br />Your Child's journey starts here</h1>
          <p className="hero__subtitle">
            Nurturing Curiosity, Inspiring Success--since 2000
          </p>
          <div3 className="hero__buttons">
  <Link to="/admission" className="btn btn--dark">Apply Now</Link>
  <Link to="/admission" className="btn btn--outline-dark">Enroll Now</Link>
</div3>
        </div>
        <div className="hero__image-wrap">
          <div className="hero__img-main">
            <img
              src="https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=600&q=80"
              alt="School building"
            />
          </div>
          <div className="hero__badge">
            <svg viewBox="0 0 120 120" className="badge-ring">
              <path id="circle" d="M 60,60 m -45,0 a 45,45 0 1,1 90,0 a 45,45 0 1,1 -90,0" fill="none"/>
              <text fontSize="11" fill="#1a3a8c" letterSpacing="3">
                <textPath href="#circle">Admission • Admission • Admission •</textPath>
              </text>
            </svg>
          </div>
        </div>
      </section>

      {/* ===== ABOUT SECTION ===== */}
      <section className="about">
        <div className="about__label">About</div>
        <div className="about__body">
          <p>
          Little Flowers School, Rairangpur, Affiliated to CBSE, Little Flowers School has been a beacon of quality education in Rairangpur since 2000. We blend academic rigor with moral values to shape responsible citizens of tomorrow.
          </p>
          <p>
            We Believe In:
Learning with Purpose - Activity-based CBSE curriculum that goes beyond textbooks
Growing with Values - Discipline, respect, and integrity at the core of everything we do
Leading with Confidence - Sports, debates, cultural programs to build 21st-century skillsWith state-of-the-art facilities and caring educators, we provide a nurturing space where every flower blooms to its fullest potential.
          </p>
          <p>
            At Little Flowers School, we don't just teach students — we prepare future leaders. From kindergarten to senior secondary, we walk with your child at every step of their educational journey.
          </p>
          <p>
            While maintaining the traditional values of the we have created
            a path-breaking paradigm in school education.
          </p>
          <a href="Admission" className="read-more">Read More <span className="arrow-circle">→</span></a>
        </div>
      </section>

      {/* ===== HERO BANNER (dark blue) ===== */}
      <section className="hero-banner">
        <div className="hero-banner__text">
          <h2>Your School for a Lifetime of Inspiring Growth</h2>
          <ul className="feature-list">
            <li>
              <span className="feat-icon">⊞</span>
              <span>Our Faculties</span>
            </li>
            <li>
              <span className="feat-icon">📄</span>
              <span>Infrastructure &amp; Facilities</span>
            </li>
            <li>
              <span className="feat-icon">🌐</span>
              <span>Co-Curricular Programs</span>
            </li>
            <li>
              <span className="feat-icon">🎓</span>
              <span>Enroll Now</span>
            </li>
          </ul>
        </div>
        <div className="hero-banner__image">
          <img
            src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?w=700&q=80"
            alt="Graduating student"
          />
        </div>
      </section>

      {/* ===== PRINCIPAL MESSAGE ===== */}
      <section className="principal">
        <div className="principal__images">
          <div className="img-grid">
            <img src="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=200&q=80" alt="students" />
            <img src="https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=200&q=80" alt="students" />
            <img src="https://images.unsplash.com/photo-1509062522246-3755977927d7?w=200&q=80" alt="students" />
            <img src="https://images.unsplash.com/photo-1580582932707-520aed937b7b?w=200&q=80" alt="school" />
          </div>
        </div>
        <div className="principal__content">
          <h2>Hear From Our Masters</h2>
          <p>
            <em>Education is the process of gaining knowledge, skills, values and attitudes through learning and teaching. It can happen in schools, at home, in the community or through self-study and it helps people develop their thinking and prepare for life.</em>
          </p>
          <div className="principal__signature">
            <div className="principal__avatar">
              <img
                src={principalImg} 
                alt="Principal"
              />
            </div>
            <div>
              <strong>Mr.Debabrata Das</strong>
              <span className="title-role">Principal</span>
            </div>
          </div>
        </div>
      </section>

      {/* ===== ENROLLMENT SECTION ===== */}
      <section className="enroll">
        <div className="enroll__header">
          <h2>Enroll Today!</h2>
          <p>Explore Our Application process and Events here</p>
          <Link to="/admission" className="btn btn--outline-white">Apply Now</Link>
        </div>
        <div className="enroll__steps">
          {[
            {
              num: '1',
              title: 'Book a tour',
              desc: 'Get a firsthand look at our vibrant learning environment. Schedule a visit to explore our campus and see how we foster holistic growth.',
            },
            {
              num: '2',
              title: 'Application Process',
              desc: 'Begin your journey with us. Understand the steps and requirements to enroll your child at Little flowers school, ensuring a smooth admission process.',
            },
            {
              num: '3',
              title: 'Enrollment Meeting',
              desc: "Meet with our admissions team to discuss your child's educational needs and how Little flowers school can support their academic and personal growth.",
            },
            {
              num: '4',
              title: 'Enrollment Confirmation',
              desc: "Finalize your child's place at LFS. Confirm enrollment and prepare to embark on a transformative educational experience.",
            },
          ].map((step) => (
            <div className="step-card" key={step.num}>
              <span className="step-num">{step.num}</span>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ===== CONTACT SECTION ===== */}
      <section className="contact">
        <div className="contact__info">
          <h2>Have Any Queries?</h2>
          <p className="contact__sub">Let Us Call You</p>
          <p>Feel Free to contact us and we will get back to you as we can</p>
          <ul className="contact__details">
            <li>📋 Affiliation No. 1530473, Rairangpur  PO, Mayurbhanj, Odisha, India – 757043</li>
            <li>✉️ lfsrkrrpmbj@gmail.com</li>
            <li>📞 7655022486</li>
            <li>📍 Location</li>
          </ul>
          <div className="contact__coord">
            <strong>Coordinator Details</strong>
            <p>👤 —riutmurmu@gmail.com</p>
            <p>📞 —9692904115</p>
          </div>
        </div>
        <div className="contact__form-wrap">
          <div className="contact__form">
            <h3>Send Us A Message</h3>
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email" />
            <input type="tel" placeholder="Contact Number" />
            <textarea placeholder="Message" rows="3"></textarea>
            <div className="captcha-placeholder">
              <input type="checkbox" id="robot" />
              <label htmlFor="robot">I'm not a robot</label>
            </div>
            <button className="btn-submit">Submit</button>
          </div>
        </div>
      </section>
    </main>
     </>
  );
};

export default Homepage;